import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { UserPermissionSchema } from '@lotta/shared/types-types';

export type GetPermissionsParams = Static<typeof GetPermissionsParamsSchema>;
export const GetPermissionsParamsSchema = Type.Object(
  {},
  { additionalProperties: false, $id: 'GetRetailUnitResponseSchema' }
);

export type GetPermissionsResponse = Static<typeof GetPermissionsResponseSchema>;
export const GetPermissionsResponseSchema = Type.Object(
  { permissions: Type.Array(UserPermissionSchema) },
  {
    additionalProperties: false,
    $id: 'GetRetailUnitResponseSchema',
  }
);
